<template>
  <Dropdown
    v-model="selectedShow"
    :options="showsList"
    option-label="show_title"
    option-value="show_id"
    placeholder="All Shows"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-96"
    input-class="tw-text-xl md:tw-text-2xl tw-font-black tw-p-0 tw-leading-normal tw-font-heading"
    panel-class="tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-lg xl:tw-max-w-2xl"
    filter
    @change="emits('selectShow', selectedShow)"
  >
  </Dropdown>
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const emits = defineEmits(["selectShow"]);

const store = useStore();

const token = localStorage.getItem("podcasterToken");

const showsList = computed(() => {
  let tempShowList = store.getters.shows;
  if (!tempShowList) {
    tempShowList = [];
  }
  tempShowList = tempShowList.map((item) => ({ ...item }));
  tempShowList.unshift({ show_id: "all", show_title: "All Shows" });
  return tempShowList;
});
const selectedShow = ref("all");

const fetchShows = () => {
  store.dispatch("loadShows", {
    token,
    fields: ["show_id", "show_title", "podcaster_id"],
  });
};

onMounted(() => {
  fetchShows();
});
</script>
